import CorporationSettingsService from '@/services/CorporationSettingsService';

export const corporationSettingsState = {
  namespaced: true,
  state: {
    corporationSettings: { logFileName: null, backgroundFileName: null },
  },
  mutations: {
    SET(state, corporationSettings) {
      state.corporationSettings = corporationSettings;
    },
  },
  getters:{
    corporationSettings: state => state.corporationSettings,

    logoUrl: state => {
      if (state.corporationSettings.logoFileName) {
        return CorporationSettingsService.getServedMediaAssetsUrl() + '/logo/' + state.corporationSettings.logoFileName;
      }
      return null;
    },
    backgroundImageUrl: state => {
      if (state.corporationSettings.backgroundFileName) {
        return CorporationSettingsService.getServedMediaAssetsUrl() + '/background/' + state.corporationSettings.backgroundFileName;
      }
      return null;
    },
    backgroundTransparencyPercent: state => {
      return state.corporationSettings.backgroundTransparencyPercent;
    },

  },
  actions: {
    update: (context) =>{
      CorporationSettingsService.getSettings().then(result => {
        context.commit('SET', result.data);
      });
    },
  },
};
